<div class="text-center" [ngStyle]="{'margin-top': withmargin ? '120px' : '0', 'margin-bottom': withmargin ? '120px' : '0'}">
  <i class="fa fa-spinner fa-pulse fa-3x fa-fw spinner" aria-hidden="true"></i>
</div>
